export class SystemConstants {
    public static CURRENT_USER = 'CURRENT_USER';
    public static BASE_API = 'https://api.congchungtructuyen.vn';
}